import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { timeoutMs: Number };

  connect() {
    this.clearTimeout();

    if (!this.hasTimeoutMsValue || this.timeoutMsValue <= 0) return;
    if (!this.element.querySelector(".Panel")) return;

    this._timeoutId = setTimeout(() => this.hide(), this.timeoutMsValue);
  }

  disconnect() {
    this.clearTimeout();
  }

  hide() {
    this.element.style.display = "none";
  }

  clearTimeout() {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
      this._timeoutId = null;
    }
  }
}
